export const productName = 'ELECTRICAL ENGINEERING TEACHER READY';
export const productShortName = 'Electrical Engineering Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/4kvPSfhmovVnP9F4CTpWyC/MOCKUP_5.41.53_p._m..png';

export const checkoutUrl = 'https://electrical-engineering-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more sleepless nights searching for explanations',
  "No more rushed lessons with materials that don't work",
  'No more disconnected students',
  'No more weekends building from scratch',
  'No more awkward silences when students ask questions',
];
